module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.4211496.ttf";